var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotifyIconActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "#FF6600",
    stroke: "#FF6600"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75371_780)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(8 8)",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.61 8.15005C31.235 7.96605 30.788 8.12005 30.604 8.49005L27.74 14.2661L26.037 12.4561C25.754 12.1531 25.279 12.1401 24.977 12.4241C24.675 12.7081 24.661 13.1841 24.945 13.4841L27.388 16.0801C27.531 16.2301 27.728 16.3151 27.934 16.3151C27.97 16.3151 28.007 16.3121 28.044 16.3071C28.287 16.2711 28.496 16.1171 28.606 15.8971L31.948 9.15705C32.132 8.78505 31.98 8.33505 31.608 8.15105L31.61 8.15005ZM27.018 24.6251C26.935 24.5611 24.974 23.0001 25.008 18.8651C25.03 16.4321 24.228 14.2691 22.752 12.7751C21.428 11.4351 19.636 10.6921 17.706 10.6831H17.693C15.763 10.6931 13.971 11.4331 12.647 12.7751C11.172 14.2701 10.37 16.4331 10.39 18.8671C10.426 23.0001 8.46701 24.5601 8.39001 24.6201C8.13001 24.8131 8.02301 25.1501 8.12401 25.4581C8.22601 25.7661 8.51401 25.9731 8.83601 25.9731H12.916C13.004 28.5431 15.109 30.6131 17.701 30.6131C20.293 30.6131 22.399 28.5431 22.486 25.9731H26.568C26.888 25.9731 27.172 25.7671 27.275 25.4631C27.378 25.159 27.273 24.8201 27.019 24.6251H27.018ZM17.7 28.5131C16.266 28.5131 15.1 27.3861 15.016 25.9731H20.384C20.299 27.3861 19.134 28.5131 17.7 28.5131Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75371_780"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifyIconActive);
export default __webpack_public_path__ + "static/media/notifyIconActive.53ff0ca40123602aee59119bcb2c4df9.svg";
export { ForwardRef as ReactComponent };